@use './styles/revo-grid.mixin.scss' as *;
@use './styles/revo-grid.common.scss' as *;
@use './styles/revo-grid.default.scss' as *;
@use './styles/revo-grid.material.scss' as *;
@use './styles/revo-grid.dark.material.scss' as *;
@use './styles/revo-grid.dark.compact.scss' as *;
@use './styles/revo-grid.compact.scss' as *;
@use './styles/revo-grid.rtl.scss' as *;
@use '../../global/_icons.scss' as *;

revo-grid {
  /* Base theme variables */
  --revo-grid-primary: #266ae8;
  --revo-grid-primary-transparent: rgba(38, 106, 232, 0.9);
  --revo-grid-background: #fff;
  --revo-grid-foreground: black;
  --revo-grid-divider: gray;
  --revo-grid-shadow: rgba(0, 0, 0, 0.15);
  --revo-grid-text: black;
  --revo-grid-border: rgba(0, 0, 0, 0.2);
  
  /* Filter panel variables */
  --revo-grid-filter-panel-bg: #fff;
  --revo-grid-filter-panel-border: #d9d9d9;
  --revo-grid-filter-panel-shadow: rgba(0, 0, 0, 0.15);
  --revo-grid-filter-panel-input-bg: #eaeaeb;
  --revo-grid-filter-panel-divider: #d9d9d9;
  --revo-grid-filter-panel-select-border: transparent;
  --revo-grid-filter-panel-select-border-hover: transparent;

  /* Grid specific variables */
  --revo-grid-header-bg: #f8f9fa;
  --revo-grid-header-color: #000;
  --revo-grid-header-border: #cecece;
  --revo-grid-cell-border: #e2e3e3;
  --revo-grid-focused-bg: rgba(233, 234, 237, 0.5);
  --revo-grid-row-hover: #f1f1f1;
  --revo-grid-row-headers-bg: #f7faff;
  --revo-grid-row-headers-color: #757a82;
  --revo-grid-cell-disabled-bg: rgba(0, 0, 0, 0.07);
  
  /* Dark theme overrides - applied when theme contains 'dark' */
  &[theme*='dark'] {
    --revo-grid-background: #212529;
    --revo-grid-foreground: #fff;
    --revo-grid-text: rgba(255, 255, 255, 0.9);
    --revo-grid-divider: #505050;
    --revo-grid-border: rgba(255, 255, 255, 0.2);

    /* Filter panel variables */
    --revo-grid-filter-panel-bg: #212529;
    --revo-grid-filter-panel-border: #505050;
    --revo-grid-filter-panel-input-bg: #343a40;
    --revo-grid-filter-panel-divider: #505050;

    --revo-grid-header-bg: #343a40;
    --revo-grid-header-color: #fff;
    --revo-grid-header-border: #505050;
    --revo-grid-cell-border: #424242;
    --revo-grid-focused-bg: rgba(52, 58, 64, 0.5);
    --revo-grid-row-hover: rgba(80, 80, 80, 0.5);
    --revo-grid-row-headers-bg: rgba(52, 58, 64, 0.8);
    --revo-grid-row-headers-color: rgba(255, 255, 255, 0.8);
    --revo-grid-cell-disabled-bg: rgba(255, 255, 255, 0.07);
  }
  
  @include revoGridCommon;
  
  /*
  * Grid required to have a flex property to be able to stretch
  */
  display: flex !important;
  height: 100%;
  /**
  * In some cases the min-height is not enough for safari
  * so setting up the grid  height works
  */
  min-height: 300px;
  font-family: Helvetica, Arial, Sans-Serif, serif;
  font-size: 14px;
  position: relative;
  color: var(--revo-grid-text);

  @include noSelect;

  .attribution {
    $size: 4px;
    $color: var(--revo-grid-primary-transparent);

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    width: 0;
    height: 0;
    border-left: $size solid $color;
    border-bottom: $size solid $color;
    border-top: $size solid transparent;
    border-right: $size solid transparent;
    cursor: pointer;

    .value {
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: var(--revo-grid-background);
      padding: 4px;
      border-radius: 4px;
      box-shadow: 0 1px 10px var(--revo-grid-border);
      white-space: nowrap;
      text-decoration: none;
      color: var(--revo-grid-text);
      letter-spacing: 0.3px;
      font-size: 11px;
      opacity: 0;
      width: $size;
      overflow: hidden;
      transition: opacity 0.5s ease-in-out, width 0.3s ease-in-out;
    }

    &:hover {
      .value {
        width: 63px;
        opacity: 1;
      }
    }
  }

  &.column-draggable.column-drag-start {
    &, * {
      &:hover {
        cursor: grabbing;
      }
    }
  }

  .footer-wrapper,
  .header-wrapper {
    width: 100%;

    revogr-data {
      z-index: 3;
    }
  }

  revo-dropdown {
    width: 100%;

    .rv-dr-root {
      max-height: 100%;
    }
    &.shrink label {
      opacity: 0;
    }
  }

  .viewports {
    // max-height: 100%; // for safari
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-grow: 1;
  }

  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .main-viewport {
    flex-grow: 1;
    height: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  .draggable {
    $s: 30px;
    position: fixed;
    height: $s;
    line-height: $s;
    background: var(--revo-grid-background);
    border-radius: 3px;
    display: block;
    z-index: 100;
    margin-top: 5px;
    margin-right: -20px;
    box-shadow: 0 4px 20px 0 var(--revo-grid-shadow);
    padding-left: 20px;
    padding-right: 5px;

    &.hidden {
      display: none;
    }

    .revo-alt-icon {
      $alt-icon-color: var(--revo-grid-foreground);
      background-color: $alt-icon-color;
      position: absolute;
      left: 5px;
      top: 10px;
    }
  }

  .draggable-wrapper {
    &.hidden {
      display: none;
    }
  }

  .drag-position {
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
    z-index: 2;
    background: var(--revo-grid-divider);
    pointer-events: none;
  }

  .drag-position-y {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 1px;
    z-index: 2;
    background: var(--revo-grid-divider);
    pointer-events: none;
  }

  .drag-auto-scroll-y {
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
    height: 50px;
    width: 1px;
  }

  .clipboard {
    position: absolute;
    left: 0;
    top: 0;
  }

  revogr-scroll-virtual {
    position: relative;
    &.vertical,
    &.horizontal {
      z-index: 3;
    }
  }
}
